import { useAppParams } from "@router/router-helper";
import {
  companyMemberGroupsSelector,
  companyMemberGroupsStatusSelector,
} from "@store/company-member-groups/company-member-groups-selector";
import {
  CompanyMemberGroupEntity,
  resetCompanyMemberGroupsState,
} from "@store/company-member-groups/company-member-groups-slice";
import { fetchCompanyMemberGroups } from "@store/company-member-groups/company-member-groups-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { FetchingStatus } from "@store/store-types";
import { useEffect } from "react";

interface UseMemberGroups {
  /** Groups that the member belongs to */
  groups: CompanyMemberGroupEntity[];

  /** The status of the endpoint */
  companyMemberGroupsStatus: FetchingStatus;
}

/** Fetches the groups of a company member */
export function useMemberGroups(): UseMemberGroups {
  const dispatch = useAppDispatch();
  const { memberId, teamId } = useAppParams();
  const groups = useAppSelector(companyMemberGroupsSelector);
  const companyMemberGroupsStatus = useAppSelector(
    companyMemberGroupsStatusSelector
  );

  // Fetch the company members groups
  useEffect(() => {
    const id = memberId || teamId;
    if (id) {
      void dispatch(fetchCompanyMemberGroups({ memberId: id }));
    }

    return () => {
      /* Clean the store for the company members group */
      dispatch(resetCompanyMemberGroupsState());
    };
  }, [dispatch, memberId, teamId]);

  return { groups, companyMemberGroupsStatus };
}
